/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */


import BaseCookie from "@/core/js/Cookie/BaseCookie";
import {router} from "@/router"

export class RedirectCookie extends BaseCookie{

	constructor() {
		super('gcoriginr');
	}

	saveRedirectPath(path){
		this.save(path)
	}
	saveRedirectOrigin(route){
		this.save({
			name: route.name,
			params: route.params,
			query: route.query,
			hash: route.hash
		})
	}
	getRedirectOrigin(){
		return this.get()
	}
	goToRedirectOriginAndClear(){
		let origin = this.getAndClear()
		if(origin){
			router.push(origin).catch(error => console.log(error))
			return true
		}
		return false
	}

}



